// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1bah1h6o{justify-content:center}
._1e0c1txw{display:flex}
._4cvr1h6o{align-items:center}
._6rthu2gc{margin-block-end:var(--ds-space-100,8px)}
._bozg1jfw{padding-inline-start:var(--ds-space-500,40px)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/empty-state/dist/esm/styled/actions-container.compiled.css"],"names":[],"mappings":"AAAA,WAAW,sBAAsB;AACjC,WAAW,YAAY;AACvB,WAAW,kBAAkB;AAC7B,WAAW,wCAAwC;AACnD,WAAW,6CAA6C","sourcesContent":["._1bah1h6o{justify-content:center}\n._1e0c1txw{display:flex}\n._4cvr1h6o{align-items:center}\n._6rthu2gc{margin-block-end:var(--ds-space-100,8px)}\n._bozg1jfw{padding-inline-start:var(--ds-space-500,40px)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
